import { ethers } from './ethers-peer'

export const JsonRpcSigner = ethers.providers.JsonRpcSigner
